'use client';

import { ApiCallWrapper } from '@/src/components/ui/api-call-wrapper/ApiCallWrapper';

export default function Loading() {
  return (
    <div className={'min-h-[51.5vh]'}>
      <ApiCallWrapper isLoading={true} setError={() => null} />
    </div>
  );
}
